import styled from 'styled-components';

export const NamePostContainer = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  font-family: 'Formular bold';
  font-size: 12px;

  h3{
    letter-spacing: -.72px;
    line-height: 17px;
    margin: 0 0 2px;
  }

  h4{
    opacity: .5;
    font-size: 12px;
    letter-spacing: -.72px;
    line-height: 17px;
  }
`;